import React, { useEffect, useState, useRef } from 'react';
import {observer} from "mobx-react-lite";
import Seo from "../components/Seo";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Text from "../components/Games/Text";
import Filter from "../components/Games/Filter";
import NoResult from "../components/NoResult";
import {useObserver} from "../hooks/useObserver";
import Loading from "../components/Loading";
import PostService from "../API/PostService";
import {useFetching} from "../hooks/useFetching";

import {API_GAMES_LIST} from "../utils/consts";
import GameBox from "../components/GameBox";
import {useLocation} from 'react-router-dom'
import Loader from "../components/Loader";

// import image from '../img/Bananas.png'

const GamesPage = () => {
    const {search} = useLocation();
    const searchParams = new URLSearchParams(search);

    const [isLoading, setIsLoading] = useState(false);
    const [games, setGames] = useState([]);
    const [isLoadingText, setIsLoadingText] = useState(true);
    // const [games, setGames] = useState([ { id: 1, game_id: '1065', top_game: true, game_new: true, name: 'Rise Of Imperium', game_type: 'slot', free_game: false, image: image, game_reels: '7', bonus_game: true, play_game_url: 'https://demo.championstudio.net/?p=%7B%22back_url%22%3A%20%22https%3A//championstudio.net/ru/game/65/%22%2C%20%22game_id%22%3A%201063%2C%20%22login_code%22%3A%20%22%5B%5B00000000000000%5D%5D%22%2C%20%22game_exit%22%3A%20%22%5B%5Bclose%5D%5D%22%7D', }, { id: 2, game_id: '1065', top_game: true, game_new: true, name: 'Rise Of Imperium', game_type: 'slot', free_game: false, image: image, game_reels: '7', bonus_game: true, play_game_url: 'https://demo.championstudio.net/?p=%7B%22back_url%22%3A%20%22https%3A//championstudio.net/ru/game/65/%22%2C%20%22game_id%22%3A%201063%2C%20%22login_code%22%3A%20%22%5B%5B00000000000000%5D%5D%22%2C%20%22game_exit%22%3A%20%22%5B%5Bclose%5D%5D%22%7D', }, { id: 3, game_id: '1065', top_game: true, game_new: true, name: 'Rise Of Imperium', game_type: 'slot', free_game: false, image: image, game_reels: '7', bonus_game: true, play_game_url: 'https://demo.championstudio.net/?p=%7B%22back_url%22%3A%20%22https%3A//championstudio.net/ru/game/65/%22%2C%20%22game_id%22%3A%201063%2C%20%22login_code%22%3A%20%22%5B%5B00000000000000%5D%5D%22%2C%20%22game_exit%22%3A%20%22%5B%5Bclose%5D%5D%22%7D', }, { id: 4, game_id: '1065', top_game: true, game_new: true, name: 'Rise Of Imperium', game_type: 'slot', free_game: false, image: image, game_reels: '7', bonus_game: true, play_game_url: 'https://demo.championstudio.net/?p=%7B%22back_url%22%3A%20%22https%3A//championstudio.net/ru/game/65/%22%2C%20%22game_id%22%3A%201063%2C%20%22login_code%22%3A%20%22%5B%5B00000000000000%5D%5D%22%2C%20%22game_exit%22%3A%20%22%5B%5Bclose%5D%5D%22%7D', }, { id: 5, game_id: '1065', top_game: true, game_new: true, name: 'Rise Of Imperium', game_type: 'slot', free_game: false, image: image, game_reels: '7', bonus_game: true, play_game_url: 'https://demo.championstudio.net/?p=%7B%22back_url%22%3A%20%22https%3A//championstudio.net/ru/game/65/%22%2C%20%22game_id%22%3A%201063%2C%20%22login_code%22%3A%20%22%5B%5B00000000000000%5D%5D%22%2C%20%22game_exit%22%3A%20%22%5B%5Bclose%5D%5D%22%7D', }, { id: 6, game_id: '1065', top_game: true, game_new: true, name: 'Rise Of Imperium', game_type: 'slot', free_game: false, image: image, game_reels: '7', bonus_game: true, play_game_url: 'https://demo.championstudio.net/?p=%7B%22back_url%22%3A%20%22https%3A//championstudio.net/ru/game/65/%22%2C%20%22game_id%22%3A%201063%2C%20%22login_code%22%3A%20%22%5B%5B00000000000000%5D%5D%22%2C%20%22game_exit%22%3A%20%22%5B%5Bclose%5D%5D%22%7D', } ]);
    const [postLength, setPostLength] = useState(8);
    const [page, setPage] = useState(0);
    const lastElement = useRef(null);

    const [fetchPosts] = useFetching(async (page, searchParams, clearData) => {
        setIsLoading(true);
        try {
            await PostService.getAll(API_GAMES_LIST, page, searchParams).then((response) => {
                clearData
                    ? setGames(response.data?.games)
                    : setGames([...games, ...response.data?.games]);
                setPostLength(response.data.games.length);
                setPage(page + 1);
            });
        } finally {
            setIsLoading(false);
        }
    });

    useObserver(lastElement, postLength >= 8, isLoading, () => {
        fetchPosts(page, searchParams, false);
    });

    useEffect(() => {
        fetchPosts(0, new URLSearchParams(search), true);
    }, [search]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div className="container_fluid">
            <Seo page='games' />
            <div className="catalog background">
                <Header />
                <div className="details_content content">
                    <div className="new_games">
                        <Text setIsLoadingText={setIsLoadingText} />
                        {isLoadingText && <Loader />}
                        <Filter isLoadingText={isLoadingText} />
                        <div className="row">
                            <div id="js-scroll_loading" className="boxing_games">
                                {games.length > 0 && games.map(game => <GameBox key={game.id} game={game}/>)}
                            </div>
                            <div ref={lastElement} className="lastElement" />
                            {isLoading
                                ? <Loading />
                                : !games.length && <NoResult />}
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </div>
    );
};

export default observer(GamesPage);